import { Card } from "primereact/card"
import styles from '../../styles.module.css'
import { Badge } from "primereact/badge"
import { Button } from "primereact/button"

interface MessageProps {
  key: string
  role: string
  index: number
  interviewerName: string
  questionNumber: number
  message: string
  handleRetrieveRecording: (index: number) => void
}

const MessageBox = (props: MessageProps) => {

  const { role, index, interviewerName, questionNumber, message } = props
  let userMsgBoolean = role === 'USER'

  const MsgHeader = userMsgBoolean ? <div className="font-semibold text-green-600 pt-3 pl-3">{role}</div> : <div className="font-semibold text-blue-600 pt-3 pl-3">{interviewerName}</div>
  const MsgFooter = <div className="text-right text-xs">Q{questionNumber}</div>
  const MsgBody = <div className="text-left">{message}</div>

  return (
    <div className="m-2 scalein animation-ease-in animation-duration-500 animation-iteration-1">
      <div className={styles.chatbot}>
        {userMsgBoolean ?
          <div className="flex justify-content-end align-items-center">
            <Card header={MsgHeader} style={{ width: 'fit-content', minWidth: '100px', backgroundColor: '#d4ecd5', borderRadius: '8px' }}>
              <div className="p-0">
                {MsgBody}
              </div>
            </Card>
            <Button icon="pi pi-video" className="p-button-rounded p-button-secondary ml-2" tooltip="Retrieve Recording" tooltipOptions={{ position: 'bottom' }} onClick={() => props.handleRetrieveRecording(index)} />
          </div>
          :
          <div className="flex justify-content-start">
            <Card className="justify-content-start" header={MsgHeader} footer={MsgFooter} style={{ width: 'fit-content', minWidth: '100px', backgroundColor: '#cae6fc', borderRadius: '8px' }}>
              <div className="p-0">
                {MsgBody}
              </div>
            </Card>
          </div>}
      </div>
    </div>
  )
}

export default MessageBox